import { getSession } from 'next-auth/react';
import { isClientSide } from '../Analytics/AnalyticsUtil';
import { validateSessionToken } from '../api/ApiUtils';

export const getValidClientToken = async () => {
  if (!isClientSide()) throw new Error('getValidClientToken can only be used client side');
  const session = await getSession();
  return validateSessionToken(session);
};
